import { RemoveMemberAbsenceModal } from './RemoveMemberAbsenceModal';

export default RemoveMemberAbsenceModal;